import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DeleteAccountProcedure = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      {/* Logo */}
      <Box display="flex" justifyContent="flex-start" mb={4}>
        <img
          src="https://www.connectoverseas.com/images/logo.png" // Adjust path if needed
          alt="Visa Info - Connect Overseas Logo"
          style={{ width: 180, height: "auto" }}
        />
      </Box>

      <Typography variant="h4" gutterBottom align="center">
        Delete Account Procedure
      </Typography>

      <Typography variant="body1" paragraph>
        At <strong>Visa Info - Connect Overseas</strong>, we respect your right to manage your data,
        including the option to delete your account permanently from our system.
      </Typography>

      <Typography variant="h6" gutterBottom>
        How to Delete Your Account
      </Typography>

      <Typography variant="body1" paragraph>
        You can delete your account at any time using one of the following methods:
      </Typography>

      <ul>
        <li>
          <Typography variant="body1" paragraph>
            <strong>In-App Option:</strong> Go to the <em>Profile</em> section of the app, scroll down, and tap on <strong>"Delete Account"</strong>. Follow the confirmation steps to complete the process.
          </Typography>
        </li>
        <li>
          <Typography variant="body1" paragraph>
            <strong>Request via Email:</strong> You can request account deletion by emailing our support team at{" "}
            <a href="mailto:enquiry@connectoverseas.com">enquiry@connectoverseas.com</a>. Please include your registered email or phone number in the message for verification.
          </Typography>
        </li>
      </ul>

      <Typography variant="h6" gutterBottom>
        What Happens After Deletion
      </Typography>

      <Typography variant="body1" paragraph>
        Once your account is deleted:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">All personal data, messages, and session history will be permanently removed.</Typography>
        </li>
        <li>
          <Typography variant="body1">You will no longer have access to voice calls, video calls, or chat history.</Typography>
        </li>
        <li>
          <Typography variant="body1">Your data will not be shared or sold at any time during or after deletion.</Typography>
        </li>
      </ul>

      <Typography variant="h6" gutterBottom>
        Need Help?
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions or issues with deleting your account, feel free to contact our support team:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">📧 Email: <a href="mailto:enquiry@connectoverseas.com">enquiry@connectoverseas.com</a></Typography>
        </li>
      </ul>

      <Typography variant="body2" color="textSecondary" mt={4}>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>
    </Container>
  );
};

export default DeleteAccountProcedure;
